<script lang="ts">
  // SRP: EditorHeader only handles the header layout
  // Delegates AI model selection and subscription display to child components
  import type { GrammarStats } from '$lib/stores/grammar'
  import type { GrammarError } from '$lib/types/grammar'
  import SubscriptionBadge from './SubscriptionBadge.svelte'
  import { sidebarStore } from '$lib/stores/sidebarStore'
  import { PanelRightClose, PanelRightOpen } from 'lucide-svelte'

  interface Props {
    stats: GrammarStats
    isChecking: boolean
    onStatusMessage?: (message: string | null) => void
    showDevIndicator?: boolean
  }

  let { stats, isChecking, onStatusMessage, showDevIndicator = true }: Props = $props()
  
  // Sidebar state
  let sidebarState = $state({ isCollapsed: false })
  
  $effect(() => {
    const unsubscribe = sidebarStore.subscribe(state => {
      sidebarState = { isCollapsed: state.isCollapsed }
    })
    return unsubscribe
  })
  
  function toggleSidebar() {
    sidebarStore.toggle()
  }
</script>

<header class="editor-header">
  <!-- Subscription Badge Component -->
  <SubscriptionBadge />
  
  <!-- Sidebar Toggle Button -->
  <button
    class="sidebar-toggle"
    onclick={toggleSidebar}
    title={sidebarState.isCollapsed ? '사이드바 열기 (⌘/)' : '사이드바 닫기 (⌘/)'}
    aria-label={sidebarState.isCollapsed ? '사이드바 열기' : '사이드바 닫기'}
    aria-keyshortcuts="Cmd+/"
    aria-expanded={!sidebarState.isCollapsed}
  >
    {#if sidebarState.isCollapsed}
      <PanelRightOpen size={16} />
    {:else}
      <PanelRightClose size={16} />
    {/if}
  </button>
</header>

<style>
  .editor-header {
    display: flex;
    align-items: center;
    gap: 8px;
    background: transparent;
    -webkit-app-region: no-drag;
  }
  
  .sidebar-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: var(--text-secondary);
    cursor: pointer;
    transition: all 0.2s ease;
    -webkit-app-region: no-drag;
  }
  
  .sidebar-toggle:hover {
    background: var(--bg-tertiary);
    color: var(--text-primary);
  }
  
  .sidebar-toggle:active {
    transform: scale(0.95);
  }

  /* Theme toggle logo styles moved to ThemeToggleLogo.svelte */

  /* Dark mode handled by CSS variables */

  /* Responsive Design */
  @media (max-width: 768px) {
    .editor-header {
      padding: 4px 12px;
    }
    
    /* Removed unused .header-center selector */
  }
</style>